<template>
  <div class="bg-card border border-border rounded-lg shadow-sm p-4 text-center">
    <div class="text-2xl font-semibold mb-1" :class="valueColorClass">
      <slot name="value">0</slot>
    </div>
    <div class="text-sm font-semibold text-muted-foreground">
      <slot name="label">Default Label</slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  color: {
    type: String,
    // A validator ensures only predefined colors are used
    validator: (value) => ['gray', 'amber', 'purple', 'green', 'blue', 'red'].includes(value),
    default: 'gray'
  }
})

// Map simple color names to full, static Tailwind classes
const colorClassMap = {
  gray: 'text-gray-800',
  amber: 'text-amber-600',
  purple: 'text-purple-600',
  green: 'text-green-600',
  blue: 'text-blue-600',
  red: 'text-red-600',
  newPrimary: 'text-newPrimary'
};

// A computed property to get the correct class based on the prop
const valueColorClass = computed(() => colorClassMap[props.color]);
</script>